/**
 * Comuna a la que va el pedido (task-1379).
 *
 * Las reglas de productos segmentadas por comuna se deciden con la comuna de
 * DESPACHO, no con cualquier dirección que el cliente tenga guardada. El checkout
 * la registra acá cada vez que cambia la dirección elegida, y el carrito y las
 * reglas la mandan al backend para que el descuento que se ve sea el mismo que
 * después calcula la orden con la dirección real.
 */
const CLAVE = 'delivery_comuna';

const limpiar = (valor) => (typeof valor === 'string' ? valor.trim() : '');

/** @returns {string|null} */
export const getDeliveryComuna = () => {
  if (typeof localStorage === 'undefined') return null;
  try {
    return limpiar(localStorage.getItem(CLAVE)) || null;
  } catch {
    return null;
  }
};

/**
 * Guarda la comuna. Devuelve true si cambió, para que quien llama sepa si hay
 * que volver a consultar las reglas.
 */
export const saveDeliveryComuna = (comuna) => {
  if (typeof localStorage === 'undefined') return false;
  const nueva = limpiar(comuna);
  const actual = getDeliveryComuna() || '';
  if (nueva === actual) return false;
  try {
    if (nueva) {
      localStorage.setItem(CLAVE, nueva);
    } else {
      localStorage.removeItem(CLAVE);
    }
  } catch {
    return false;
  }
  return true;
};

/** Parámetro `comuna` para las llamadas al backend, vacío si no hay. */
export const comunaParams = () => {
  const comuna = getDeliveryComuna();
  return comuna ? { comuna } : {};
};

export default getDeliveryComuna;
